// Load-more — przycisk „Pokaż więcej" na archiwach produktowych.
// Pobiera kolejną stronę archiwum (?paged=N), parsuje HTML, dokleja karty produktów do bieżącej siatki.
// Brak własnego endpointu AJAX — używamy istniejącego URL paginacji, więc działa to spójnie z głównym query.
//
// PRZYWRACANIE POZYCJI (2026-08-15): theme ustawia `history.scrollRestoration = 'manual'`
// (main.js), a doładowane strony żyją tylko w DOM — po wejściu w produkt i cofnięciu klient
// lądował na czystej stronie 1, u góry. Zapamiętujemy więc w sessionStorage, ile stron było
// doładowanych i którą kartę kliknięto, a przy powrocie WSTECZ dogrywamy strony i wracamy
// do klikniętej karty. Świeże wejście (menu, link) celowo zaczyna od góry — przywracamy
// wyłącznie nawigację typu back/forward.

const KB_LM_TTL = 30 * 60 * 1000; // 30 min — po dłuższej przerwie powrót od góry jest naturalny

function kbLmKey() {
  return 'kb-listing:' + location.pathname + location.search;
}

function kbLmNavType() {
  const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  return nav ? nav.type : '';
}

function initLoadMore() {
  const btn = document.querySelector('[data-load-more]');
  const grid = document.querySelector('[data-products-grid]');
  if (!btn || !grid) return;

  const baseUrl = btn.dataset.baseUrl;
  const maxPages = parseInt(btn.dataset.maxPages, 10);
  if (!baseUrl || !maxPages || maxPages <= 1) return;

  const originalLabel = btn.textContent.trim();

  function aktualizujLicznik(appendedCount) {
    const wrap = btn.closest('[data-load-more-wrap]');
    if (!wrap) return;
    const shownEl = wrap.querySelector('[data-load-more-shown]');
    const progressEl = wrap.querySelector('[data-load-more-progress]');
    const total = parseInt(btn.dataset.total, 10) || 0;
    if (!shownEl) return;
    const newShown = Math.min((parseInt(shownEl.textContent, 10) || 0) + appendedCount, total);
    shownEl.textContent = newShown;
    if (progressEl && total > 0) {
      progressEl.style.width = Math.min(100, Math.round((newShown / total) * 100)) + '%';
    }
  }

  async function dograjStrone(nextPage, animuj) {
    const sep = baseUrl.includes('?') ? '&' : '?';
    const res = await fetch(baseUrl + sep + 'paged=' + nextPage, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('HTTP ' + res.status);
    const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
    const incoming = doc.querySelector('[data-products-grid]');
    if (!incoming) throw new Error('No grid in fetched HTML');

    // Liczymy PRZED pętlą — appendChild PRZENOSI elementy, po pętli incoming jest puste.
    const appendedCount = incoming.children.length;
    const frag = document.createDocumentFragment();
    Array.from(incoming.children).forEach((card) => {
      if (animuj) {
        card.style.opacity = '0';
        card.style.transition = 'opacity 240ms ease-out';
      }
      frag.appendChild(card);
    });
    grid.appendChild(frag);
    if (animuj) {
      requestAnimationFrame(() => {
        Array.from(grid.children).forEach((c) => { c.style.opacity = ''; });
      });
    }

    btn.dataset.page = String(nextPage);
    aktualizujLicznik(appendedCount);
    if (nextPage >= maxPages) {
      btn.style.display = 'none'; // counter+progress zostają — pokazują 100%
    }
    return appendedCount;
  }

  btn.addEventListener('click', async () => {
    if (btn.disabled) return;
    btn.disabled = true;
    btn.textContent = 'Ładuję…';
    try {
      await dograjStrone(parseInt(btn.dataset.page, 10) + 1, true);
    } catch (err) {
      console.error('load-more', err);
    }
    if (btn.style.display !== 'none') {
      btn.disabled = false;
      btn.textContent = originalLabel;
    }
  });

  // ── Zapamiętanie stanu przy wejściu w produkt ──
  // Delegacja na siatce: łapie też karty doładowane później. Zapisujemy przy mousedown/
  // touchstart (nie click), żeby zdążyć przed nawigacją także przy otwarciu w nowej karcie.
  function zapiszStan(e) {
    const link = e.target.closest && e.target.closest('a[href*="/produkt/"]');
    if (!link || !grid.contains(link)) return;
    try {
      sessionStorage.setItem(kbLmKey(), JSON.stringify({
        page: parseInt(btn.dataset.page, 10) || 1,
        href: link.getAttribute('href'),
        scrollY: window.scrollY,
        ts: Date.now(),
      }));
    } catch (_) { /* pełny storage — trudno, powrót od góry */ }
  }
  grid.addEventListener('mousedown', zapiszStan);
  grid.addEventListener('touchstart', zapiszStan, { passive: true });

  // ── Przywracanie przy powrocie wstecz ──
  async function przywroc() {
    let stan = null;
    try { stan = JSON.parse(sessionStorage.getItem(kbLmKey()) || 'null'); } catch (_) { /* noop */ }
    if (!stan) return;

    if (kbLmNavType() !== 'back_forward' || Date.now() - (stan.ts || 0) > KB_LM_TTL) {
      // Świeże wejście albo stęchły stan — sprzątamy, listing zaczyna normalnie.
      try { sessionStorage.removeItem(kbLmKey()); } catch (_) { /* noop */ }
      return;
    }
    const obecna = parseInt(btn.dataset.page, 10) || 1;
    if (stan.page > obecna) {
      btn.disabled = true;
      btn.textContent = 'Przywracam widok…';
      try {
        for (let p = obecna + 1; p <= Math.min(stan.page, maxPages); p++) {
          await dograjStrone(p, false); // bez animacji — wracamy do stanu, nie pokazujemy nowości
        }
      } catch (err) {
        console.error('load-more restore', err);
      }
      if (btn.style.display !== 'none') {
        btn.disabled = false;
        btn.textContent = originalLabel;
      }
    }
    // Wracamy do klikniętej karty — kotwiczenie po elemencie, nie po pikselach, bo leniwe
    // zdjęcia zmieniają wysokości i zapamiętany scrollY potrafi wskazać inne miejsce.
    const karta = stan.href
      ? Array.from(grid.querySelectorAll('a[href*="/produkt/"]')).find((a) => a.getAttribute('href') === stan.href)
      : null;
    requestAnimationFrame(() => {
      if (karta) {
        karta.scrollIntoView({ block: 'center' });
      } else if (stan.scrollY) {
        window.scrollTo(0, stan.scrollY);
      }
    });
  }

  // bfcache (pageshow persisted) przywraca DOM i scroll samo — wtedy nic nie robimy,
  // bo btn.dataset.page w zachowanym DOM już zgadza się ze stanem.
  przywroc();
}

if (typeof document !== 'undefined') {
  if (document.readyState !== 'loading') initLoadMore();
  else document.addEventListener('DOMContentLoaded', initLoadMore);
}

export {};
